import { useContext } from 'react';
import { UserContext, UserContextType } from '../providers/UserProvider';

function useUser(): UserContextType {
  return useContext(UserContext);
}

export { useUser };
